import { FunctionComponent } from "react";
import CommonDialogProps from "interfaces/CommonDialogProps";
import Dialog from "components/Dialog";

const SimpleDialog: FunctionComponent<CommonDialogProps> = (props) => <Dialog {...props}/>;

export default SimpleDialog;
